export const features = [{
    name: 'cookie-bar',
    description: 'Cookie bar',
    active: false
}];